// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gzsn","questions":"styles_questions__3WFw_","footer":"styles_footer__2AlkL"};